import React from 'react';
import { Typography, Button, ConfigProvider } from 'antd';
import { Link } from 'react-router-dom';
import { careProviderConfiguration } from '../../store';
import { useAtom } from 'jotai';

const PATIENT_SUBMISSION_MESSAGE
  = 'Thank you for taking the time to provide feedback. Your well being is our top priority. Your answers have been submitted and our staff will review them and follow up if needed.';

const STAFF_SUBMISSION_MESSAGE
  = 'Thank you for taking the time to provide feedback. Your answers have been submitted.';

interface EndOfSurveyMessageProps {
  isStaffInteraction?: boolean;
}

const EndOfSurveyMessage = ({
  isStaffInteraction = false,
}: EndOfSurveyMessageProps) => {
  const [careProviderStyles] = useAtom(careProviderConfiguration);
  const { Text } = Typography;
  const submissionMessage = isStaffInteraction
    ? STAFF_SUBMISSION_MESSAGE
    : PATIENT_SUBMISSION_MESSAGE;

  return (
    <div
      style={{
        textAlign: 'center',
        whiteSpace: 'pre-line',
        fontSize: '14px',
        marginTop: '20px',
      }}
    >
      <Text data-cy="end_message">{submissionMessage}</Text>
      <div
        style={{
          textAlign: 'center',
          marginTop: '20px',
          whiteSpace: 'pre-line',
          fontSize: '14px',
        }}
      >
        <ConfigProvider
          theme={{
            token: {
              colorPrimary: careProviderStyles.colorPrimary,
            },
          }}
        >
          <Link
            data-cy="landing-page-redirect"
            to="../../landing-page"
            relative="path"
          >
            <Button
              type="primary"
              block
              style={{
                height: '40px',
                width: 'auto',
              }}
              shape="round"
            >
              Return to Home Page
            </Button>
          </Link>
        </ConfigProvider>
      </div>
    </div>
  );
};

export default EndOfSurveyMessage;
